__turbopack_context__.v({
  "content": "category-card-module-scss-module__QnuQaa__content",
  "image": "category-card-module-scss-module__QnuQaa__image",
  "name": "category-card-module-scss-module__QnuQaa__name",
  "root": "category-card-module-scss-module__QnuQaa__root",
});
